import React from 'react'
import { useTranslation } from 'react-i18next'
import Spinner from '@components/Spinner'
import Error from '@components/Error'
import { Button } from '@components/Button/Button'
import Footer from '@components/Footer'
import Header from '@components/Header'
import Page from '@components/Page'
import { Body } from './components/Body'
import { useChoiceState } from '@context/ChoiceContext'
import { HandleSelectTreatment } from '@customTypes/HandleSelectTreatment'
import { CategorizedTreatmentsWithPartialTreatments } from '@customTypes/CategorizedTreatment'
import { TEST_IDS } from 'src/constants/testIds'

interface Props {
  categorizedTreatments?: CategorizedTreatmentsWithPartialTreatments[]
  loading?: boolean
  selectedTreatmentId: string | undefined
  handleSelectTreatment: HandleSelectTreatment
  handleNextClicked: () => void
}

export const TreatmentScreen = ({
  categorizedTreatments = [],
  loading,
  selectedTreatmentId,
  handleSelectTreatment,
  handleNextClicked,
}: Props) => {
  const { t } = useTranslation()
  const { treatmentBundleTypeReferenceId } = useChoiceState()
  const clinicHasTreatments = !loading && categorizedTreatments.length > 0

  return (
    <Page
      header={
        <Header
          desktopHeadingText={clinicHasTreatments ? t('treatment_page_desktop_headline') : ''}
          hideStatusBar={!clinicHasTreatments}
        />
      }
      body={
        <>
          {loading && <Spinner center />}
          {!loading &&
            (categorizedTreatments.length ? (
              <Body
                categorizedTreatments={categorizedTreatments}
                handleSelectTreatment={handleSelectTreatment}
                selectedTreatmentId={selectedTreatmentId}
              />
            ) : (
              <Error />
            ))}
        </>
      }
      footer={
        treatmentBundleTypeReferenceId && !loading ? (
          <Footer
            button={
              <Button
                fullSize
                type="button"
                onClick={handleNextClicked}
                data-test={TEST_IDS.nextButton}
                text={t('next')}
              />
            }
          />
        ) : undefined
      }
    />
  )
}
